var specialProduct1 = false;
var specialProduct2 = false;
var maxCakeTextCharacters = 25;

function limitCakeTextInput(input) {
  var value = input.value;
  var limitedValue = '';
  var characterCount = 0;

  for (var i = 0; i < value.length; i++) {
    var character = value.charAt(i);

    if (!/\s/.test(character)) {
      characterCount++;
    }

    if (characterCount <= maxCakeTextCharacters) {
      limitedValue += character;
    }
  }

  if (limitedValue !== value) {
    input.value = limitedValue;
  }
}

function activateCakeTextLimit() {
  var cakeTextField = jqCR('.extra_input_1_wrapper').find('input[type="text"], input:not([type]), textarea').first();

  if (!cakeTextField.length) {
    return;
  }

  if (!cakeTextField.attr('data-cake-text-limit')) {
    cakeTextField.attr('data-cake-text-limit', maxCakeTextCharacters);
    cakeTextField.after('<p class="cake-text-limit-note" style="margin-top: 0.4rem; font-size: 0.9em;">Maximum 25 characters, spaces not counted.</p>');
  }

  cakeTextField.off('input.cakeTextLimit').on('input.cakeTextLimit', function () {
    limitCakeTextInput(this);
  });

  limitCakeTextInput(cakeTextField.get(0));
}

for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  //console.log({itemTitle})  
  console.log('-->', itemCollections)
 
  if (itemCollections.toLowerCase().indexOf('Cakes'.toLowerCase()) > -1) {
    specialProduct1 = true;
  } 

  if (itemTitle.toLowerCase().indexOf('text on cake'.toLowerCase()) > -1) {
    specialProduct2 = true;
  } 
}

document.addEventListener('crJQActivated', function (e) {
  if (specialProduct1 === false || specialProduct2 === false) {
    jqCR('.extra_input_1_wrapper').remove()
  } else {
    activateCakeTextLimit()
  }
})
